import { render } from "./WomensCouncil.vue?vue&type=template&id=2a54b683&scoped=true"
import script from "./WomensCouncil.vue?vue&type=script&lang=js"
export * from "./WomensCouncil.vue?vue&type=script&lang=js"

import "./WomensCouncil.vue?vue&type=style&index=0&id=2a54b683&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a54b683"]])

export default __exports__